import React, { useEffect, useState } from "react";
import "./DesktopLoginContents.scss";

const DesktopLoginContents = () => {
  const slidingLists = [
    {
      image: "/images/logins/1.svg",
      title: "From shelf to success, Create your account now! ",
      desc: "Take command of your stock with precision and ease. Our inventory management system puts the power of real-time tracking at your fingertips, ensuring you're always in control.",
    },
    {
      image: "/images/logins/2.svg",
      title: "From shelf to success, Create your account now! ",
      desc: "Take command of your stock with precision and ease. Our inventory management system puts the power of real-time tracking at your fingertips, ensuring you're always in control.",
    },
    {
      image: "/images/logins/1.svg",
      title: "From shelf to success, Create your account now! ",
      desc: "Take command of your stock with precision and ease. Our inventory management system puts the power of real-time tracking at your fingertips, ensuring you're always in control.",
    },
    {
      image: "/images/logins/2.svg",
      title: "From shelf to success, Create your account now! ",
      desc: "Take command of your stock with precision and ease. Our inventory management system puts the power of real-time tracking at your fingertips, ensuring you're always in control.",
    },
  ];

  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((pre) => (pre === slidingLists.length - 1 ? 0 : pre + 1));
    }, 4000);

    return () => clearInterval(interval);
  }, []);
  return (
    <div className="desktop-login-contents">
      <div className="details-slide-list">
        <img src={slidingLists[activeIndex]?.image} alt="" aria-label="Source" />
        <p className="title">{slidingLists[activeIndex]?.title}</p>
        <p>{slidingLists[activeIndex]?.desc}</p>
      </div>

      <div className="navigator-list">
        {slidingLists.map((el, i) => {
          return (
            <div
              className={`navigator ${activeIndex === i ? "active" : ""}`}
              key={i}
              onClick={() => {
                setActiveIndex(i);
              }}
            ></div>
          );
        })}
      </div>
    </div>
  );
};

export default DesktopLoginContents;
